import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

export const connectedApplicationSortOptions: OptionsDictionary = {
  [OrderKeys.name]: SortOptions.name,
  [OrderKeys.connectedApplicationClientId]: SortOptions.connectedApplicationClientId,
  [OrderKeys.connectedApplicationStatus]: SortOptions.connectedApplicationStatus,
  [OrderKeys.createdAt]: SortOptions.createdAt,
  [OrderKeys.connectedApplicationTrustType]: SortOptions.connectedApplicationTrustType,
  [OrderKeys.connectedApplicationAuthorizationServerType]: SortOptions.connectedApplicationAuthorizationServerType,
};
